import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentCompanyId } from 'src/modules/companies/slices';
import { useContactCaptureService } from '../services';

export const useContactCaptureRecordController = (id?: string) => {
  const companyId = useSelector(getCurrentCompanyId) as string | undefined;
  const service = useContactCaptureService();

  const load = useCallback(async () => {
    if (!companyId || !id) return;
    // The service stores errors only for the current request.
    await service.read(companyId, id).catch(() => undefined);
  }, [companyId, id, service.read]);

  useEffect(() => {
    service.clearSelected();
    void load();
    return service.clearSelected;
  }, [load, service.clearSelected]);

  return {
    companyId,
    record: service.selected?.companyId === companyId && service.selected?.id === id ? service.selected : null,
    loading: service.loading.read,
    error: service.recordError,
    retry: load,
    create: service.create,
    update: service.update,
    publish: service.publish,
    remove: service.remove,
    mutateStatus: service.mutateStatus,
  };
};
